/* Volver Lover — theme.js
   Cart drawer (AJAX), add-to-cart, quantity steppers, PDP gallery, marquee. */
(function () {
  'use strict';

  var moneyFormat = (window.Shopify && Shopify.currency && Shopify.currency.active) ? null : null;

  function formatMoney(cents) {
    // Shopify stores prices in cents; render with the shop's format if available.
    var amount = (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return amount + ' €';
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var itemCountEl = document.querySelector('[data-cart-itemcount]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
    if (itemCountEl) itemCountEl.textContent = cart.item_count + (cart.item_count === 1 ? ' libro' : ' libros');

    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="ico">\u2766</div><p style="font-family:var(--serif);font-style:italic;font-size:20px;margin-top:16px">Tu cesta est\u00e1 vac\u00eda,<br>pero llena de posibilidades.</p></div>';
      if (foot) foot.setAttribute('hidden', '');
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var img = item.image ? '<img src="' + item.image + '&width=160" alt="" style="aspect-ratio:2/3;object-fit:cover;border-radius:2px">' : '<div style="aspect-ratio:2/3;background:var(--cream-3)"></div>';
      html += '<div class="cart-line">' + img +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        '<div class="cart-line__author">' + (item.vendor || '') + '</div>' +
        '<div class="cart-line__price">' + item.quantity + ' \u00d7 ' + formatMoney(item.price) + '</div>' +
        '<button class="cart-line__remove" type="button" data-remove="' + item.key + '">Quitar</button></div>' +
        '</div>';
    });
    body.innerHTML = html;

    if (foot) {
      foot.removeAttribute('hidden');
      var totalEl = foot.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      var shipEl = foot.querySelector('[data-cart-shipping]');
      if (shipEl) {
        var threshold = 3500; // 35 €
        if (cart.total_price >= threshold) {
          shipEl.textContent = '\u2713 Env\u00edo gratis incluido';
        } else {
          shipEl.textContent = 'Te faltan ' + formatMoney(threshold - cart.total_price) + ' para env\u00edo gratis';
        }
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'A\u00f1adiendo\u2026'; }
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = original || 'A\u00f1adir a la cesta'; }
        openDrawer();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- Global event wiring ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); fetchCart(); return; }

    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) {
      e.preventDefault(); closeDrawer(); return;
    }

    var remove = e.target.closest('[data-remove]');
    if (remove) { e.preventDefault(); changeQty(remove.getAttribute('data-remove'), 0); return; }

    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      e.preventDefault();
      var wrap = (minus || plus).closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        v = plus ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      }
    }

    var thumb = e.target.closest('.pdp__thumb[data-thumb]');
    if (thumb) {
      var main = document.getElementById('pdpMainImage');
      if (main) main.src = thumb.getAttribute('data-thumb');
      document.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') === -1 && form.id !== 'product-form') return;
    if (form.id === 'product-form') {
      e.preventDefault();
      addToCart(form);
    }
  });

  // Initial sync of the badge count
  if (document.querySelector('[data-cart-count]')) fetchCart();
})();
